module.exports = __webpack_public_path__ + "a5d8d2c4c6e897758aefbd34c4f10bb6.png";